// TanStack Query 전역 클라이언트
// - 모바일은 네트워크 변동성↑ → retry 2 + staleTime 30s
// - mutations는 retry X (멱등성 미보장)

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      staleTime: 30 * 1000, // 30초
      refetchOnWindowFocus: false, // 모바일에선 의미 적고 트래픽 낭비
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
